import { AddressInfoFragment, ParcelInfoFragment } from "domains/Task/graphql/fragments";
import gql from "graphql-tag";

export const RunsheetInfoFragment = gql`
  fragment RunsheetInfo on Runsheet {
    _id
    runsheet_UID
    runsheet_status
    runsheet_vehicle_type
    runsheet_amount_to_collect
    runsheet_created_by
    runsheet_created_at
    runsheet_is_deleted
    runsheet_last_edited_by
    runsheet_last_edited_at
    runsheet_parcels {
      ...ParcelInfo
    }
    runsheet_driver_UID
    runsheet_vehicle_UID
    runsheet_conveyor_UID
  }
  ${ParcelInfoFragment}
`;

export const DriverInfoFragment = gql`
  fragment DriverInfo on Driver {
    _id
    driver_UID
    driver_firstname
    driver_lastname
    driver_email
    driver_phone_number
    driver_username
    driver_password
    driver_address {
      ...AddressInfo
    }
    driver_profile_picture
    driver_id_card
    driver_id_card_type
    driver_license
    driver_criminal_record
    driver_proof_of_address
    driver_emergency_contact_firstname
    driver_emergency_contact_lastname
    driver_emergency_contact_phone_number
    driver_is_paid_by_paps
    driver_contract_end
    driver_contract_start
    driver_is_trained
    driver_is_available
    driver_created_at
    driver_updated_at
    driver_is_deleted
  }
  ${AddressInfoFragment}
`;
export const ConveyorInfoFragment = gql`
  fragment ConveyorInfo on Conveyor {
    _id
    conveyor_UID
    conveyor_firstname
    conveyor_lastname
    conveyor_email
    conveyor_phone_number
    conveyor_username
    conveyor_password
    conveyor_address {
      ...AddressInfo
    }
    conveyor_profile_picture
    conveyor_id_card
    conveyor_id_card_type
    conveyor_criminal_record
    conveyor_proof_of_address
    conveyor_emergency_contact_firstname
    conveyor_emergency_contact_lastname
    conveyor_emergency_contact_phone_number
    conveyor_contract_end
    conveyor_contract_start
    conveyor_is_trained
  }
  ${AddressInfoFragment}
`;

export const SubTaskInfoFragment = gql`
  fragment SubTaskInfo on SubTask {
    _id
    subtask_for_paps
    subtask_UID
    subtask_status
    subtask_type
    subtask_operation_on_parcel {
      ...ParcelInfo
    }
    subtask_client_UID
    subtask_address {
      ...AddressInfo
    }
    subtask_address {
      ...AddressInfo
    }

    subtask_execution_date
    subtask_execution_slot_start
    subtask_execution_slot_end
    subtask_created_at
    subtask_last_edited_at

    subtask_driver {
      ...DriverInfo
    }
    subtask_conveyor {
      ...ConveyorInfo
    }
    subtask_recipient{
      receiver_firstname
      receiver_lastname
    }
  }
  ${ParcelInfoFragment}
  ${AddressInfoFragment}
  ${DriverInfoFragment}
  ${ConveyorInfoFragment}
`;
